import { Controller } from "@hotwired/stimulus"

// Floating action button over a scrolling list (mobile Messages). The pill
// shows its label at rest and collapses to the icon while the user scrolls
// down; scrolling back up, or returning to the top, expands it again.
//
//   <div data-controller="mobile-fab">
//     <a class="mobile-fab" data-mobile-fab-target="button">…</a>
//     <turbo-frame data-mobile-fab-target="scroller">…</turbo-frame>
//   </div>
//
// The scroller is bound per target, not once on connect: on Referrals it
// sits inside a Turbo Frame that pill switches and searches replace.
export default class extends Controller {
  static targets = ["button", "scroller"]
  static classes = ["compact"]

  // Ignore sub-threshold jitter (rubber-banding, momentum settle).
  static THRESHOLD = 6

  // Stimulus fires target callbacks before connect(), so the handler has to
  // be bound here or the first scroller is wired to an unbound method.
  initialize() {
    this.lastTop = 0
    this.ticking = false
    this.onScroll = this.onScroll.bind(this)
  }

  scrollerTargetConnected(el) {
    el.addEventListener("scroll", this.onScroll, { passive: true })
    this.lastTop = 0
    this.expand()
  }

  scrollerTargetDisconnected(el) {
    el.removeEventListener("scroll", this.onScroll)
  }

  expand() {
    if (this.hasButtonTarget) this.buttonTarget.classList.remove(this.compactClassName)
  }

  get compactClassName() {
    return this.hasCompactClass ? this.compactClass : "mobile-fab--compact"
  }

  onScroll(event) {
    if (this.ticking) return
    this.ticking = true
    const scroller = event.currentTarget
    requestAnimationFrame(() => {
      this.update(scroller.scrollTop)
      this.ticking = false
    })
  }

  update(top) {
    const delta = top - this.lastTop
    const compactClass = this.compactClassName

    if (top <= 0) {
      this.buttonTarget.classList.remove(compactClass)
    } else if (delta > this.constructor.THRESHOLD) {
      this.buttonTarget.classList.add(compactClass)
    } else if (delta < -this.constructor.THRESHOLD) {
      this.buttonTarget.classList.remove(compactClass)
    }

    this.lastTop = Math.max(top, 0)
  }
}
